import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import SignInPage from "../Components/SignIn";
import SignUpPage from "../Components/SignUpPage";
import ForgetPassword from "../Components/ForgetPassword";
import Otp from "../Components/Otp";
import ResetPassword from "../Components/ResetPassword";
import MainPage from "../Components/MainPage";
import Features from "../Components/Features";
import About from "../Components/About";
import ContactPage from "../Components/ContactPage";
import UpcomingInterviews from "../pages/Dashoabrd/UpcomingInterviews";
import AddInterview from "../pages/Dashoabrd/UpcomingInterviews/AddInterview";
import RescheduleInterview from "../pages/Dashoabrd/UpcomingInterviews/RescheduleInterview";
import CompletedInterviews from "../pages/Dashoabrd/CompletedInterviews";
import InterviewDetails from "../pages/Dashoabrd/CompletedInterviews/InterviewDetails";
import Candidates from "../pages/Dashoabrd/Candidates";
import Dashboard from "../pages/Dashoabrd";
import AuthGuard from "../Guards/AuthGuard";
import SignGuard from "../Guards/SignGuard";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="main" />} />
      <Route
        path="/signup"
        element={
          <SignGuard>
            <SignUpPage />
          </SignGuard>
        }
      />
      <Route
        path="/signin"
        element={
          <SignGuard>
            <SignInPage />
          </SignGuard>
        }
      />
      <Route
        path="/forget-password"
        element={
          <SignGuard>
            <ForgetPassword />
          </SignGuard>
        }
      />
      <Route
        path="/otp"
        element={
          <SignGuard>
            <Otp />
          </SignGuard>
        }
      />
      <Route
        path="/reset-password"
        element={
          <SignGuard>
            <ResetPassword />
          </SignGuard>
        }
      />
      <Route path="/main" element={<MainPage />} />
      <Route path="/features" element={<Features />} />
      <Route path="/about-us" element={<About />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route
        path="/dashboard"
        element={
          <AuthGuard>
            <Dashboard />
          </AuthGuard>
        }
      />
      <Route
        path="/interview-upcomming"
        element={
          <AuthGuard>
            <UpcomingInterviews />
          </AuthGuard>
        }
      />
      <Route
        path="/interview-upcomming/add"
        element={
          <AuthGuard>
            <AddInterview />
          </AuthGuard>
        }
      />
      <Route
        path="/interview-upcomming/reschedule/:id"
        element={
          <AuthGuard>
            <RescheduleInterview />
          </AuthGuard>
        }
      />

      <Route
        path="/candidates"
        element={
          <AuthGuard>
            <Candidates />
          </AuthGuard>
        }
      />

      <Route
        path="/interview-completed"
        element={
          <AuthGuard>
            <CompletedInterviews />
          </AuthGuard>
        }
      />
      <Route
        path="/interview-completed/:id"
        element={
          <AuthGuard>
            <InterviewDetails />
          </AuthGuard>
        }
      />
    </Routes>
  );
};

export default Routing;
